import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, CheckCircle, Clock, MapPin, Shield, MessageCircle, Wrench, Battery, Car } from 'lucide-react';
import { services, whatsappLink, coverageAreas } from '../mock';

const Home = () => {
  const iconMap = {
    'Wrench': Wrench,
    'Battery': Battery,
    'Car': Car
  };

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white pt-32 pb-20">
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
              7/24 Mobil Yol Yardım
              <span className="block text-orange-500 mt-2">Kadıköy'de Yanınızdayız</span>
            </h1>
            <p className="text-lg md:text-xl mb-8 text-gray-300">
              Lastik tamiri, akü değişimi ve tüm yol yardım ihtiyaçlarınız için anında hizmet. Bir telefon kadar yakınız!
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center space-x-2 bg-green-500 text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-green-600 transition-all transform hover:scale-105 shadow-xl"
              >
                <MessageCircle className="w-6 h-6" />
                {/* DEĞİŞİKLİK 1: Metin "WhatsApp" olarak güncellendi */}
                <span>WhatsApp</span>
              </a>
              <a
                href="tel:05534834264"
                className="inline-flex items-center justify-center space-x-2 bg-orange-600 text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-orange-700 transition-all transform hover:scale-105 shadow-xl"
              >
                <Phone className="w-6 h-6" />
                <span>Hemen Ara</span>
              </a>
            </div>
            
            {/* DEĞİSİKLİK 2: Telefon numarası kaldırıldı */}
            {/* <p className="mt-6 text-2xl font-bold text-orange-400">0553 483 42 64</p> */}

          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-orange-100 rounded-full mb-4">
                <Clock className="w-8 h-8 text-orange-600" />
              </div>
              <h3 className="text-lg font-semibold mb-2">7/24 Hizmet</h3>
              <p className="text-gray-600 text-sm">Her gün, her saat hizmetinizdeyiz</p>
            </div>
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mb-4">
                <Shield className="w-8 h-8 text-blue-600" />
              </div>
              <h3 className="text-lg font-semibold mb-2">Güvenilir</h3>
              <p className="text-gray-600 text-sm">Profesyonel ve deneyimli ekip</p>
            </div>
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mb-4">
                <MapPin className="w-8 h-8 text-green-600" />
              </div>
              <h3 className="text-lg font-semibold mb-2">Hızlı Ulaşım</h3>
              <p className="text-gray-600 text-sm">20-30 dakikada yerinizde</p>
            </div>
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-purple-100 rounded-full mb-4">
                <CheckCircle className="w-8 h-8 text-purple-600" />
              </div>
              <h3 className="text-lg font-semibold mb-2">Uygun Fiyat</h3>
              <p className="text-gray-600 text-sm">Şeffaf fiyatlandırma</p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Hizmetlerimiz
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Profesyonel ekibimizle tüm yol yardım ihtiyaçlarınız için yanınızdayız
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {services.map((service) => {
              const IconComponent = iconMap[service.icon];
              return (
                <div
                  key={service.id}
                  className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-all transform hover:-translate-y-2 p-8"
                >
                  <div className="flex items-center justify-center w-20 h-20 bg-gradient-to-br from-orange-500 to-red-600 rounded-2xl mb-6 mx-auto">
                    {IconComponent && <IconComponent className="w-10 h-10 text-white" />}
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 mb-4 text-center">{service.description}</p>
                  <ul className="space-y-2">
                    {service.features.map((feature, index) => (
                      <li key={index} className="flex items-center text-sm text-gray-700">
                        <CheckCircle className="w-4 h-4 text-green-500 mr-2 flex-shrink-0" />
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              );
            })}
          </div>

          <div className="text-center mt-12">
            <Link
              to="/hizmetler"
              className="inline-flex items-center px-8 py-3 bg-orange-600 text-white font-semibold rounded-lg hover:bg-orange-700 transition-colors"
            >
              Tüm Hizmetleri Gör
            </Link>
          </div>
        </div>
      </section>

      {/* Coverage Area */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Hizmet Bölgelerimiz
            </h2>
            <p className="text-lg text-gray-600">
              Kadıköy'ün tüm ilçelerinde hizmetinizdeyiz
            </p>
          </div>

          <div className="bg-gradient-to-br from-orange-50 to-red-50 rounded-2xl p-8">
            <div className="flex flex-wrap justify-center gap-3">
              {coverageAreas.map((area, index) => (
                <span
                  key={index}
                  className="bg-white px-4 py-2 rounded-full text-sm font-medium text-gray-700 shadow-sm hover:shadow-md transition-shadow"
                >
                  {area}
                </span>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-orange-600 to-red-600 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Acil Yol Yardımına mı İhtiyacınız Var?
          </h2>
          <p className="text-xl mb-8 opacity-90">
            7/24 hizmetinizdeyiz. Hemen bizi arayın, 20-30 dakikada yerinizde olalım!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-3 bg-green-500 text-white px-10 py-5 rounded-lg font-bold text-xl hover:bg-green-600 transition-all transform hover:scale-105 shadow-2xl"
            >
              <MessageCircle className="w-7 h-7" />
              <span>WhatsApp</span>
            </a>
            <a
              href="tel:05534834264"
              className="inline-flex items-center space-x-3 bg-white text-orange-600 px-10 py-5 rounded-lg font-bold text-xl hover:bg-gray-100 transition-all transform hover:scale-105 shadow-2xl"
            >
              <Phone className="w-7 h-7" />
              <span>0553 483 42 64</span>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;